import { LocationType } from './shipmentTypes'

// Address types
export type LocationAddress = {
  type: LocationType.DOOR
  address1: string
  address2: string
  city: string
  province: string
  postalCode: string
  country: string // 2 letter code
}

export type PortAddress = {
  type: LocationType.PORT
  portCode: string
  portName: string
  country: string // 2 letter code
}

export type AirportAddress = {
  type: LocationType.AIRPORT
  airportCode: string
  airportName: string
  country: string // 2 letter code
}

export type Address = LocationAddress | PortAddress | AirportAddress

// Type guards
export function isLocationAddress(address: Address): address is LocationAddress {
  return !!(address as LocationAddress)?.address1
}

export function isAirportAddress(address: Address): address is AirportAddress {
  return !!(address as AirportAddress)?.airportCode
}

export function isPortAddress(address: Address): address is PortAddress {
  return !!(address as PortAddress)?.portCode
}
